import React from 'react';
import { Skeleton } from '@mui/material';

import './mobile-product-detail-page-skeleton-style.scss';

import MobileHeaderSkeleton from '@src/componentsNew/Skeleton/mobile/components/MobileHeaderSkeleton';

import { SKELETON_COLOR } from "@src/utils/constants";

const MobileProductDetailPageSkeleton = () => {
  return (
    <div id="mobile-product-detail-page-skeleton-wrapper">
      <MobileHeaderSkeleton isMain={false} hasBorderBottom={false} />

      <Skeleton variant="rectangular" width="100%" style={{ backgroundColor: SKELETON_COLOR, height: "unset", aspectRatio: "390/469" }} />

      <div className="text-area">
        <div className='icon-text-area'>
          <Skeleton variant="rectangular" width={60} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />

          <div className="icon-wrapper">
            <Skeleton variant="circular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR }} />
            <Skeleton variant="circular" width={24} height={24} style={{ backgroundColor: SKELETON_COLOR }} />
          </div>
        </div>
        <Skeleton variant="rectangular" width={260} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
        <Skeleton variant="rectangular" width={205} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4, marginTop: 12 }} />
        <Skeleton variant="rectangular" width={225} height={24} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 4 }} />
      </div>

      <Skeleton variant="rectangular" height={46} style={{ backgroundColor: SKELETON_COLOR, borderRadius: 30, marginRight: 16, marginLeft: 16 }} />
    </div>
  );
};

export default MobileProductDetailPageSkeleton;
